export default __webpack_public_path__ + "static/media/wavax.d6aded4e.svg";